import OnePercentForThePlanet from './OnePercentForThePlanet';

export default OnePercentForThePlanet;
